import { Compact, CompactRow, FieldLabel, FieldSelect } from '@newageerp/v3.bundles.form-bundle'
import { useURequest } from '@newageerp/v3.bundles.hooks-bundle';
import React, { useEffect } from 'react'

type Props = {
    period: string,
    setPeriod: (v: string) => void,
}

export default function SubPeriodFilter(props: Props) {
    const t = (e: string) => e;
    
    const { period, setPeriod } = props;

    const [doReq, reqData] = useURequest<string>('/app/plugins/Reports/ReportsFilter/periods');

    useEffect(() => {
        doReq({})
    }, []);

    return (
        <Compact>
            <CompactRow
                label={<FieldLabel>{t('Subscription period')}</FieldLabel>}
                control={
                    <FieldSelect
                        value={period}
                        onChange={setPeriod}
                        options={[
                            {
                                label: "All (monthly plans)",
                                value: "",
                            },
                            ...reqData.data.data.map(s => {
                                return (
                                    {
                                        label: s.toUpperCase(),
                                        value: s,
                                    }
                                )
                            }),
                        ]}
                    />
                }
            />
        </Compact>
    )
}

